import axios from 'axios'

const api = axios.create({
  baseURL: '/tracer',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

export function apiGetTools({ vin, componentId }) {
  return api
    .get(`/related-content/tools/${vin}/${componentId}`)
    .then((resp) => resp.data)
}
